export default __webpack_public_path__ + "static/1356-c8d6108481a28b93ac42eb32edffa283.gif";